<template>
    <div>
        <nav class="navbar navbar-expand-xxl navbar-dark bg-dark sidebarNavigation"
             data-sidebarClass="navbar-dark bg-dark">
            <div class="container">
                <router-link to="/" class="navbar-brand">
                    <img class="customer-logo" v-if="customerLogoIMG" :src="customerLogoIMG">
                    <img v-else src="@/assets/img/logo_recruitment-Accelerator.png">
                </router-link>
<!--                <button class="navbar-toggler leftNavbarToggler"-->
<!--                        type="button"-->
<!--                        v-on:click="menuIsOpen = !menuIsOpen"-->
<!--                        data-target="#navbarsExampleDefault"-->
<!--                        aria-controls="navbarsExampleDefault" aria-expanded="false" aria-label="Toggle navigation">-->
<!--                    <span class="navbar-toggler-icon"></span>-->
<!--                </button>-->
            </div>

            <div v-bind:class="{ open: menuIsOpen }" class="  sideMenu pull-right navbar-collapse"
                 id="navbarsExampleDefault">
                <ul class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <a href="https://www.recruitmentaccelerator.nl/" target="_blank" class="nav-link">
                            Home <i class="fa fa-angle-right pull-right"></i>
                        </a>

                        <a href="https://www.recruitmentaccelerator.nl/vacature-intake" target="_blank" class="nav-link">
                            Over de tool <i class="fa fa-angle-right pull-right"></i>
                        </a>

                        <a href="https://www.recruitmentaccelerator.nl/ravi/faq" target="_blank" class="nav-link">
                            FAQ <i class="fa fa-angle-right pull-right"></i>
                        </a>

                        <a href="https://www.recruitmentaccelerator.nl/Team" target="_blank" class="nav-link">
                            Over Recruitment Accelerator <i class="fa fa-angle-right pull-right"></i>
                        </a>

                        <a href="https://www.recruitmentaccelerator.nl/contact" target="_blank" class="nav-link">
                            Neem contact op <i class="fa fa-angle-right pull-right"></i>
                        </a>
                    </li>

                </ul>

            </div>
        </nav>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'Header',
    data () {
      return {
        menuIsOpen: false,
        customerLogoIMG: false
      }
    },
    watch: {
      customerConfigs (customerConfigs) {
        if (typeof customerConfigs.logo_url !== 'undefined' && customerConfigs.logo_url !== null) {
          this.customerLogoIMG = customerConfigs.logo_url
        }
      },
      $route (to, from) {
        this.menuIsOpen = false
      }
    },
    mounted () {
      if (typeof this.customerConfigs.logo_url !== 'undefined' && this.customerConfigs.logo_url !== null) {
        this.customerLogoIMG = this.customerConfigs.logo_url
      }
    },

    computed: mapGetters({
      customerConfigs: 'customer/getConfigs',
    }),

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .customer-logo {
        max-height: 36px;
    }
     .navbar-toggler-icon {
         background-image: url(
         "data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(200, 200, 200, 0.8)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E");
     }
</style>
